import styled from 'styled-components';

export const SaleResultWrapper = styled.div`
    margin-top: 150px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
